<ion-header>
	<ion-toolbar [color]="toolbarColor">
		<ion-buttons [slot]="toolbarButtonsSlot">
			<ion-button *ngIf="hasCloseButton" (click)="close()">
				<ion-icon slot="icon-only" [name]="closeIcon"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>{{ title }}</ion-title>
	</ion-toolbar>
</ion-header>